export const getVariantSizes = (product, colorName) =>
  product.colorInventoryEnabled
    ? product.colors?.find((color) => color.name === colorName)?.sizes || []
    : product.sizes || [];

export const getVariantPrice = (product, size) =>
  size?.price ?? product.salePrice ?? product.price;

export const getStockTotal = (sizes) =>
  sizes.reduce((total, entry) => total + Number(entry.countInStock || 0), 0);
